export default __webpack_public_path__ + "static/media/trash.d5ad1abd.svg";